/* eslint-disable react/prop-types */
import React from "react";
import Header from "../Components/Simulation/Header";
import Navbar from "../Components/Simulation/Navbar";
import Page from "../Components/Simulation/Page";
import { updateFirstName } from "../Store/store";

function checkData(value) {
  return value.length >= 2 && value.length <= 255;
}

export default function FirstName(props) {
  return (
    <div className="page-container">
      <Header pageIndex={props.pageIndex} totalPages={props.totalPages} />
      <Navbar pageIndex={props.pageIndex} totalPages={props.totalPages} />
      <Page
        title="Quel est votre prénom ?"
        subtitle="Pour mieux vous connaître"
        pageType="input"
        placeholder="Ex: John"
        reduxAction={updateFirstName}
        reduxStateName="firstName"
        checkData={checkData}
        dataType="string"
        myNameDb="firstName"
        pageIndex={props.pageIndex}
      />
    </div>
  );
}
